






















import { CrudService } from "../core/services/crudService";
import { Settings, TenantSettings } from "../core/services/configService";
import { Format } from "../core/helpers/formatHelper";
import Vue from "vue";
import { DateHelper } from "../core/helpers/dateHelper";
import store from "../core/store";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";

import CzPage from "../components/cz/CzPage.vue";
import CzCard from "../components/cz/CzCard.vue";
@Component({
  components: { CzPage, CzCard },
})
export default class MyOrderPage extends Vue {
  order: any = null;
  saleId: any = null;
  errorMsg: string = "";
  infoReturns: any = null;
  reload: number = 1;
  settings: TenantSettings = {};

  async mounted() {
    this.settings = store.state.settings;
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    this.saleId = this.$route.params.id;
    let url = `${Settings.HostName}/api/shop/customer-orders/${customerId}/${this.saleId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false) {
      console.error("Crash getting Your Orders");
      return;
    }

    this.order = data.model;
  }


  getProductUrl(item: any) {
    if (item === null || item === undefined || item.productId === null) {
      return "";
    }
    return "/shop/" + item.productId;
  }

  formatPrice(price: string) {
    return Format.formatCurrency(price);
  }

  getDateFormatted(dt: string) {
    return DateHelper.formatDate(new Date(dt)).split(" ")[0];
  }
}
